document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector("#PrimaryNav");

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  const fitmentForm = document.querySelector(".fitment-form");
  if (fitmentForm) {
    fitmentForm.addEventListener("submit", () => {
      const make = fitmentForm.querySelector("[data-fitment-make]")?.value || "";
      const model = fitmentForm.querySelector("[data-fitment-model]")?.value || "";
      const q = fitmentForm.querySelector('input[name="q"]');
      if (q && (make || model)) {
        q.value = [q.value, make, model].filter(Boolean).join(" ");
      }
    });
  }
});
